export const dateTimeAsFileName = (date = new Date()) => {
  const year = date.toLocaleDateString('pl', { year: 'numeric', timeZone: 'Europe/Warsaw' });
  const month = date.toLocaleDateString('pl', { month: '2-digit', timeZone: 'Europe/Warsaw' });
  const day = date.toLocaleDateString('pl', { day: '2-digit', timeZone: 'Europe/Warsaw' });
  const time = date.toLocaleTimeString('pl', { timeStyle: 'short', timeZone: 'Europe/Warsaw' }).replace(':', '_');

  return `${year}_${month}_${day}_${time}`;
};
